import { Endpoints, EnvironmentUrls } from 'Roblox';
import inventoryModule from '../inventoryModule';

const inventoryConstants = {
  urls: {
    getUserInventory: Endpoints.getAbsoluteUrl('/users/inventory/list-json'),
    getBundles: `${EnvironmentUrls.catalogApi}/v1/users/{userId}/bundles`,
    getCategories: `${EnvironmentUrls.inventoryApi}/v1/users/{userId}/categories`
  }
};

inventoryModule.constant('inventoryConstants', inventoryConstants);
export default inventoryConstants;
